import { Cemetery } from './../../models/Cemetery';
import { FirebaseService } from 'app/services/firebase.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Tombstone } from 'app/models/Tombstone';
import { Person } from 'app/models/Person';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  @Output() selectedCemeteryOutput = new EventEmitter<Array<string>>();

  toppings = new FormControl();
  toppingList: Array<string> = [];
  constructor(
    private router: Router,
    private tombstoneService: FirebaseService
  ) {}

  ngOnInit(): void {
    this.getCemeteries();
  }

  getCemeteries() {
    this.tombstoneService.getCemeteries().subscribe((res) => {
      res.forEach((e: Cemetery) => {
        this.toppingList.push(e.name);
      });
    });
  }

  filterByCemetery(value: any) {
    this.selectedCemeteryOutput.emit(value);
  }
}
